import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";
import { Section, Title } from "@vshp/ui-components";
import { Link } from "react-router-dom";
import { languagePathUrl } from "../utils/languagePathUrl";
import { useSelector } from "react-redux";

function AdvisoryBoard() {
  const { currentLanguage } = useSelector((state) => state.global);
  const { t } = useTranslation();

  let title = {
    caption: t("pages.advisory_board.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.advisory_board.title")} titleKey="pages.advisory_board.title">
        <Section border={true}>
          <p>
            <Link to={`${languagePathUrl(currentLanguage)}/advisory-board/representatives/1`} data-key="pages.advisory_board.representatives_01">
              {t("pages.advisory_board.representatives_01")}
            </Link>
          </p>
          <p>
            <Link to={`${languagePathUrl(currentLanguage)}/advisory-board/representatives/2`} data-key="pages.advisory_board.representatives_02">
              {t("pages.advisory_board.representatives_02")}
            </Link>
          </p>
          <p>
            <Link to={`${languagePathUrl(currentLanguage)}/advisory-board/representatives/3`} data-key="pages.advisory_board.representatives_03">
              {t("pages.advisory_board.representatives_03")}
            </Link>
          </p>
          <p>
            <Link to={`${languagePathUrl(currentLanguage)}/advisory-board/representatives/4`} data-key="pages.advisory_board.representatives_04">
              {t("pages.advisory_board.representatives_04")}
            </Link>
          </p>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.advisory_board.why.title">
            {t("pages.advisory_board.why.title")}
          </Title>
          <div data-key="pages.advisory_board.why.text" dangerouslySetInnerHTML={{ __html: t("pages.advisory_board.why.text") }}></div>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.advisory_board.expertise.title">
            {t("pages.advisory_board.expertise.title")}
          </Title>
          <div data-key="pages.advisory_board.expertise.text" dangerouslySetInnerHTML={{ __html: t("pages.advisory_board.expertise.text") }}></div>
        </Section>

        <Section border={true}>
          <Title type="h2" data-key="pages.advisory_board.mission.title">
            {t("pages.advisory_board.mission.title")}
          </Title>
          <div data-key="pages.advisory_board.mission.text" dangerouslySetInnerHTML={{ __html: t("pages.advisory_board.mission.text") }}></div>
        </Section>
      </Page>
    </MainLayout>
  );
}

export default AdvisoryBoard;
